export const REGIONS_ROUTES = {
  __ROOT__: '/regions',
  EDIT_REGION: '/regions/edit/:regionId',
  NEW_REGION: '/regions/new',
  VIEW_REGION: '/regions/view/:regionId',
}
